import React, { useLayoutEffect, useRef } from 'react';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import { useTheme } from '@styledComponents';
import { useIsMounted } from '@hooks/useIsMounted';
import ScrollMagic from 'scrollmagic';
import { gsap, Linear } from 'gsap';

export const useAnswersCarouselController = () => {
  const ansCarouselRef = useRef<HTMLDivElement>(null);
  const scrollController = useScrollController();
  const theme = useTheme();
  const isMounted = useIsMounted();

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;
    let answerCarouselTimeLine: ReturnType<typeof gsap.timeline>;
    const ansCarousel = ansCarouselRef.current;
    if (scrollController && isMounted && ansCarousel) {
      const initTimeline = () => {
        answerCarouselTimeLine = gsap.timeline({ paused: true, defaults: { ease: Linear.easeNone } });
        answerCarouselTimeLine.to(ansCarousel, { backgroundColor: theme.colors.yellow1 }, 0);
      };
      const initScene = () => {
        scene = new ScrollMagic.Scene({
          triggerElement: ansCarousel,
          triggerHook: 'onCenter',
          duration: '100%',
          offset: 60,
        })
          .addTo(scrollController)
          .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
            answerCarouselTimeLine?.progress(event.progress);
          });
      };
      initTimeline();
      initScene();
    }
    const clearScene = () => {
      if (answerCarouselTimeLine) {
        answerCarouselTimeLine.progress(0);
        answerCarouselTimeLine.kill();
      }
      if (scene) {
        scene.destroy(true);
      }
    };
    return () => {
      clearScene;
    };
  }, [scrollController, isMounted, ansCarouselRef, theme]);
  return {
    ansCarouselRef,
  };
};
